// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TranslationOutlinedSvg from "@fishx/icons-svg/es/asn/TranslationOutlined";
import FishxIcon from '../components/FishxIcon';

var TranslationOutlined = function TranslationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TranslationOutlinedSvg
  }));
};

TranslationOutlined.displayName = 'TranslationOutlined';
export default React.forwardRef(TranslationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TranslationOutlined.js
// module id = 4279
// module chunks = 0